module.exports = __webpack_public_path__ + "static/img/pfriemsters-ArtisanClub.ba0f60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pfriemsters-ArtisanClub.png
// module id = 300
// module chunks = 1